import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Server, Download, Network, Ticket, Users, FileText, ShoppingCart, Package, Settings, Hexagon, X } from 'lucide-react';
interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}
export function Sidebar({
  isOpen,
  onClose
}: SidebarProps) {
  const navItems = [{
    path: '/',
    label: 'Übersicht',
    icon: LayoutDashboard
  }, {
    path: '/assets',
    label: 'IT-Assets',
    icon: Server
  }, {
    path: '/updates',
    label: 'Updates',
    icon: Download
  }, {
    path: '/network',
    label: 'Netzwerk',
    icon: Network
  }, {
    path: '/tickets',
    label: 'Tickets',
    icon: Ticket
  }, {
    path: '/crm',
    label: 'CRM',
    icon: Users
  }, {
    path: '/quotes',
    label: 'Angebote',
    icon: FileText
  }, {
    path: '/orders',
    label: 'Bestellungen',
    icon: ShoppingCart
  }, {
    path: '/software',
    label: 'Software',
    icon: Package
  }, {
    path: '/settings',
    label: 'Einstellungen',
    icon: Settings
  }];
  return <aside className={`
        w-64 bg-slate-900 text-white flex flex-col h-screen fixed left-0 top-0 z-50 border-r border-slate-800
        transition-transform duration-300 ease-in-out
        ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `} data-id="element-192">
      {/* Brand */}
      <div className="h-16 flex items-center justify-between px-6 border-b border-slate-800" data-id="element-193">
        <div className="flex items-center gap-2 text-teal-400" data-id="element-194">
          <Hexagon className="h-8 w-8 fill-current" data-id="element-195" />
          <div className="flex flex-col" data-id="element-196">
            <span className="font-bold text-lg leading-none text-white tracking-tight" data-id="element-197">
              neocube
            </span>
            <span className="text-xs font-bold tracking-widest text-teal-400" data-id="element-198">
              ONE
            </span>
          </div>
        </div>

        {/* Close button - only visible on mobile */}
        <button onClick={onClose} className="lg:hidden p-2 text-slate-400 hover:text-white hover:bg-slate-800 rounded-lg transition-colors" aria-label="Menü schließen" data-id="element-199">
          <X className="h-5 w-5" data-id="element-200" />
        </button>
      </div>

      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto py-6 px-3 space-y-1" data-id="element-201">
        {navItems.map(item => <NavLink key={item.path} to={item.path} onClick={() => {
        // Close sidebar on mobile when navigating
        if (window.innerWidth < 1024) {
          onClose();
        }
      }} className={({
        isActive
      }) => `
              flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200
              ${isActive ? 'bg-teal-600 text-white shadow-lg shadow-teal-900/20' : 'text-slate-400 hover:text-white hover:bg-slate-800'}
            `} data-id="element-202">
            <item.icon className="h-5 w-5" data-id="element-203" />
            {item.label}
          </NavLink>)}
      </nav>

      {/* User Profile Snippet */}
      <div className="p-4 border-t border-slate-800" data-id="element-204">
        <div className="flex items-center gap-3 px-2 py-2 rounded-lg hover:bg-slate-800 transition-colors cursor-pointer" data-id="element-205">
          <div className="h-8 w-8 rounded-full bg-teal-500 flex items-center justify-center text-xs font-bold text-white" data-id="element-206">
            AD
          </div>
          <div className="flex flex-col" data-id="element-207">
            <span className="text-sm font-medium text-white" data-id="element-208">Admin User</span>
            <span className="text-xs text-slate-400" data-id="element-209">neocube GmbH</span>
          </div>
        </div>
      </div>
    </aside>;
}